// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"styles_modalBody__24heK","dontBreak":"styles_dontBreak__2UlaP","dividerSlim":"styles_dividerSlim__3b3V1"};